export default {
    FOR_MODAL: 80,
    FOR_NOTIFIER: 15
};
